export enum FArrangementTypesEnum {
  Theater = 1,
  Round = 2,
  Classroom = 3,
  Cabaret = 4,
  Cocktail = 5,
  Boardroom = 6,
  Ushape = 7,
}
